










import { Component, Vue, Watch } from 'vue-property-decorator';
import { TagsViewModule } from '@/store/modules/tags-view';

@Component({
  name: 'AppMain',
})
export default class extends Vue {
  get cachedViews() {
    return TagsViewModule.cachedViews;
  }

  get key() {
    return this.$route.path;
  }

  @Watch('$route')
  private onRouteChange() {
    this.addTags();
  }

  private addTags() {
    const { name } = this.$route;
    if (name) {
      TagsViewModule.addView(this.$route);
    }
    return false;
  }
}
